"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsAssets = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const material_ui_1 = require("material-ui");
const material_ui_icons_1 = require("material-ui-icons");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const store_1 = require("../../store");
require("./app-settings-assets.less");
const material_ui_2 = require("material-ui");
const material_ui_icons_2 = require("material-ui-icons");
const assetModal_1 = require("../../../../../../src/client/components/modal/assetModal");
const store_2 = require("../../../../modules/users/store"); //E-080.2
const moment = require("moment"); //E-080.2
let AppSettingsAssets = class AppSettingsAssets extends React.Component {
    constructor(props) {
        super(props);
        this.settings = null;
        this.categories = null;
        this.entityTypeList = [];
        this.required = false;
        this.dummyCat = [];
        this.generateSettings = async () => {
            const settings = await store_1.appSettingsStore.readSettings();
            const cleaned = settings
                .filter((setting) => setting.category === app_settings_1.AppCategory.assets)
                .sort((a, b) => a.displayName > b.displayName ? 1 : -1)
                .map((e) => e);
            /** Populate selections. */
            if (!this.entityTypeList.length) {
                cleaned.forEach((setting) => this.entityTypeList.push({
                    id: setting.id,
                    label: setting.displayName,
                    value: `${setting.id}`
                }));
            }
            this.settings = cleaned;
        };
        this.generateCategoryNames = async () => {
            const categories = await store_1.appSettingsStore.readConnectAsset();
            if (categories) {
                const cleaned = categories
                    .filter((category) => category.deletedAt === null)
                    .sort((a, b) => a.categoryName > b.categoryName)
                    .map((e) => e);
                this.categories = cleaned;
                this.dummyCat = cleaned;
            }
            else {
                this.categories = [];
            }
        };
        this.handleUpdateInput = () => (event, value) => {
            this.categoryNameInput = value;
        };
        //E-080.2
        this.handleEditValue = (e, index, type) => {
            this.dummyCat = this.dummyCat.map((data, i) => {
                const entry = data;
                if (data.id == index) {
                    if (type["categoryName"]) {
                        entry.categoryName = e.target.value.trim();
                        this.setState({ setInputFeild: entry.categoryName.trim() });
                        if (e.target.value.length === 0) {
                            this.setState({ isActive: true });
                        }
                        else {
                            this.setState({ isActive: false });
                        }
                    }
                }
                return entry;
            });
            this.compareDiff();
        };
        //E-080.4
        this.handleChnage = (id) => {
            if (typeof id) {
                this.setState({ isActive: false });
            }
            let data = this.categories.map((item) => {
                if (item.id == id) {
                    item.required === 1 ? (item.required = 0) : (item.required = 1);
                }
                return item;
            });
            this.dummyCat = data;
        };
        this.compareDiff = () => {
            let nameRegex = new RegExp("[a-zA-Z]{3,30}");
            if (!nameRegex.test(this.state.setInputFeild) ||
                this.state.setInputFeild === "") {
                this.setState({ warning: "Please fill the Text Feild Correctly!" });
                this.forceUpdate();
            }
            else {
                this.setState({ warning: "" });
            }
        };
        //E-080.2
        this.handleSubmit = async () => {
            const code = this.categoryNameInput; // code here is the category name input
            const categoryId = this.entityTypeChoice; // this is the app-settings.id
            const required = this.required;
            const createdBy = `${store_2.usersStore.user.value.firstName} ${store_2.usersStore.user.value.lastName}`; // E-080.2
            const createdAt = new Date(); // E-080.2
            const connectAssetCategory = {
                code,
                categoryId,
                required,
                createdBy,
                createdAt
            };
            const result = await store_1.appSettingsStore.createConnectAssetCategory(connectAssetCategory);
            this.categoryNameInput = null;
            this.entityTypeChoice = null;
            this.required = false;
            await this.generateSettings();
            await this.generateCategoryNames();
        };
        // E-080.3
        this.handleDelete = async (code, categoryId) => {
            this.setState({ codeItem: code });
            this.setState({ categoryIdItem: categoryId });
            this.handleModalOpenCancel();
        };
        this.handleEdit = async (code, categoryId) => {
            const connectAssetCategory = { code, categoryId }; // code is the connectAsset.id and categoryId is the app-setting
            this.setState({ currentEditId: code });
        };
        this.handleUpdateSelect = (value) => {
            this.entityTypeChoice = value;
        };
        this.toggleCertification = () => {
            this.required = !this.required;
        };
        // E-080
        this.handleClick = (e) => {
            this.setState({ anchorEl: e.currentTarget });
        };
        // E-080
        this.handleEditDetails = () => {
            this.setState({ isDisabled: false });
            this.setState({ anchorEl: null });
        };
        // E-080
        this.handleModalOpen = async () => {
            if (this.state.warning.length != 0) {
                this.setState({ warning: "Please fill the Text Feild Correctly!" });
            }
            else {
                this.setState({ modelOpen: true });
            }
        };
        // E-080
        this.handleCancel = async () => {
            this.categories = null;
            await this.generateSettings();
            await this.generateCategoryNames();
            this.setState({ isDisabled: true });
            this.setState({ isActive: true });
            this.dummyCat = this.categories;
            this.setState({ modelOpen: false });
            this.setState({ modelOpenCancel: false }); // E-080.3
        };
        // E-080
        this.handleConfirmEdit = async () => {
            if (this.state.warning.length != 0) {
                this.setState({ warning: "Assests has been not saved!" });
            }
            else {
                await store_1.appSettingsStore.updateConnectAssetCategory(this.dummyCat);
                this.setState({ isDisabled: true });
                this.setState({ isActive: true });
            }
            await this.setState({ modelOpen: false });
        };
        // E-080.3
        this.handleModalOpenCancel = async () => {
            this.setState({ modelOpenCancel: true });
        };
        // E-080.3
        this.handleRemove = async () => {
            const code = this.state.codeItem;
            const categoryId = this.state.categoryIdItem;
            const connectAssetCategory = { code, categoryId }; // code is the connectAsset.id and categoryId is the app-setting
            const result = await store_1.appSettingsStore.deleteConnectAssetCategory(connectAssetCategory);
            await this.generateSettings();
            await this.generateCategoryNames();
            this.setState({ isDisabled: true });
            this.setState({ modelOpenCancel: false });
        };
        this.renderAddNewCategory = () => (React.createElement("div", { className: "settings__add--wrapper", style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
            } },
            React.createElement(text_field_1.MaterialTextField, { className: "settings__add--input-asset", label: "Requirement Name", required: true, placeholder: "COI", value: this.categoryNameInput || "", onChange: this.handleUpdateInput() }),
            React.createElement(select_1.MaterialSelect, { className: "settings__add--select", options: [...this.entityTypeList], required: true, searchable: true, label: "Entity Type", onSelect: this.handleUpdateSelect, value: this.entityTypeChoice || "" }),
            React.createElement(switch_1.MaterialSwitch, { label: "Required", value: "true", checked: this.required, onChange: this.toggleCertification }),
            React.createElement(button_1.MaterialButton, { primary: true, className: "settings__add--button", disabled: !this.categoryNameInput || !this.entityTypeChoice, onClick: this.handleSubmit }, "Add"),
            React.createElement("div", { className: "Cstmbutton-wrapper" },
                React.createElement(material_ui_2.Button, { "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: this.handleClick, style: { backgroundColor: "transparent" } },
                    React.createElement(material_ui_icons_2.MoreVert, null)),
                React.createElement(material_ui_2.Menu, { id: "simple-menu", anchorEl: this.state.anchorEl, open: this.state.anchorEl, onClose: () => this.setState({ anchorEl: null }) },
                    React.createElement(material_ui_2.MenuItem, { onClick: this.handleEditDetails },
                        React.createElement(material_ui_icons_2.Edit, { style: { marginRight: 15 } }),
                        " Edit"))),
            React.createElement(button_1.MaterialButton, { primary: true, className: "settings__add--button", disabled: this.state.isActive, onClick: this.handleModalOpen }, "Save"),
            this.state.modelOpen && (React.createElement(assetModal_1.AssetModal, { title: `Are you sure you would like to edit?`, top: "200px", padding: "20px", onCancel: () => {
                    this.setState({ modelOpen: false });
                } },
                React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: 15 } },
                    React.createElement(button_1.MaterialButton, { key: "submit", primary: true, onClick: this.handleConfirmEdit, style: { marginLeft: "2em" } }, "Confirm"),
                    React.createElement(material_ui_2.Button, { style: { background: "red", marginLeft: 5, color: "#fff" }, onClick: this.handleCancel }, "Cancel")))),
            this.state.modelOpenCancel && (React.createElement(assetModal_1.AssetModal, { title: `Are you sure you would like to Remove?`, top: "200px", padding: "20px", onCancel: () => {
                    this.setState({ modelOpenCancel: false });
                } },
                React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: 15 } },
                    React.createElement(button_1.MaterialButton, { key: "submit", primary: true, onClick: this.handleRemove, style: { marginLeft: "2em" } }, "Confirm"),
                    React.createElement(material_ui_2.Button, { style: { background: "red", marginLeft: 5, color: "#fff" }, onClick: this.handleCancel }, "Cancel"))))));
        this.renderAddNote = () => (React.createElement("div", { className: "settings__add--note", style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            } },
            React.createElement(material_ui_1.Typography, null, "Note: Only one asset can belong to a category per entity type.")));
        // E-080
        this.compareChanges = () => {
            this.changed = curState !== this.originalState;
        };
        this.state = {
            status: false,
            currentEditId: "",
            anchorEl: null,
            diloagOpen: false,
            modelOpen: false,
            isActiveEditForm: true,
            isDisabled: true,
            isActive: true,
            setInputFeild: "",
            warning: "",
            modelOpenCancel: false,
            codeItem: "",
            categoryIdItem: null
        };
    }
    async componentDidMount() {
        await this.generateSettings();
        await this.generateCategoryNames();
    }
    async componentWillUnmount() {
        this.settings = null;
        this.categories = null;
    }
    renderSettings() {
        const settings = this.settings;
        const groups = [];
        const blocks = [];
        settings.forEach((setting, i) => {
            const groupName = setting.category;
            if (!groups.includes(groupName))
                groups.push(groupName);
        });
        //  this.handleEditValue(e, category[0]?.id, category[0]) E-080
        groups.forEach((group, i) => {
            blocks.push(
            // E-080.5
            React.createElement("div", { className: "settings__block settings_table", key: i, style: { overflow: "auto" } },
                this.state.warning.length > 0 ? (React.createElement("p", { style: { margin: "1em 0 0", textAlign: "center", color: "red" } },
                    this.state.warning,
                    "\u00A0")) : (""),
                React.createElement("div", { className: "settings__block-title", id: group },
                    React.createElement("span", null, group.toUpperCase()),
                    React.createElement("span", null, "User Added"),
                    React.createElement("span", null, "Date Added")),
                React.createElement("div", { className: "settings__block-entries" }, settings
                    .filter((setting) => setting.category === group)
                    .map((setting, i) => {
                    const name = setting.displayName;
                    const desc = setting.description;
                    const codes = setting.value ? setting.value.split(",") : [];
                    return (React.createElement("div", { key: i },
                        React.createElement("div", { className: "settings__block-entry" },
                            React.createElement("div", { className: "settings__block-entry--categorytitle" }, name),
                            React.createElement("div", { className: "settings__block-entry--body" },
                                React.createElement("span", { className: "settings__block-entry--body-desc" }, desc),
                                React.createElement("span", { className: "settings__block-entry--body-desc" }),
                                React.createElement("span", { className: "settings__block-entry--body-desc" }),
                                React.createElement("span", { className: "settings__block-entry--body-desc" }))),
                        React.createElement("ul", { className: "settings__rejection" }, codes.map((code, i) => {
                            var _a, _b, _c, _d;
                            const category = this.categories
                                ? this.categories.filter((category) => category.id === Number(code))
                                : [];
                            return (React.createElement(React.Fragment, null,
                                React.createElement("li", { key: i },
                                    React.createElement("div", null, ((_a = category[0]) === null || _a === void 0 ? void 0 : _a.categoryName.length) ? (React.createElement("div", { style: {
                                            display: "flex",
                                            placeItems: "center",
                                            flexWrap: "wrap",
                                        } },
                                        React.createElement("input", { style: { padding: "10px 0 10px 10px" }, onChange: (e) => {
                                                var _a;
                                                return this.handleEditValue(e, (_a = category[0]) === null || _a === void 0 ? void 0 : _a.id, category[0]);
                                            }, defaultValue: ((_b = category[0]) === null || _b === void 0 ? void 0 : _b.categoryName) || "", disabled: this.state.isDisabled }),
                                        React.createElement(switch_1.MaterialSwitch, { value: "true", checked: category[0].required ? true : false, onChange: () => { var _a; return this.handleChnage((_a = category[0]) === null || _a === void 0 ? void 0 : _a.id); }, disabled: this.state.isDisabled }),
                                        React.createElement("div", { style: {
                                                paddingLeft: "20px",
                                                display: "flex"
                                            } }, category[0].required ? (React.createElement("span", { style: { color: "red" } }, "\"Required*\"")) : (React.createElement("span", { style: {
                                                color: "red",
                                                width: "70px"
                                            } }) //E-080.2
                                        )))) : ("")),
                                    React.createElement("div", null,
                                        React.createElement("span", null,
                                            " ", (_c = category[0]) === null || _c === void 0 ? void 0 :
                                            _c.createdBy)),
                                    React.createElement("div", { style: { paddingRight: "20px" } },
                                        React.createElement("span", null, moment((_d = category[0]) === null || _d === void 0 ? void 0 : _d.createdAt).format("YYYY-MM-DD")),
                                        React.createElement("span", null, !this.state.isDisabled && (React.createElement(material_ui_icons_1.Clear, { className: "settings__rejection--clear", onClick: () => this.handleDelete(code, setting.id), color: "error" })))))));
                        }))));
                }))));
        });
        const wrapper = (React.createElement("div", { className: "settings__wrapper" },
            React.createElement("div", { className: "settings__add" }, this.renderAddNewCategory()),
            React.createElement("div", { className: "settings__add" }, this.renderAddNote()),
            React.createElement("div", { className: "settings__block" }, blocks.map((e) => e))));
        return wrapper;
    }
    render() {
        const didLoad = !!this.settings;
        return (React.createElement("div", null, didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "categories", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "entityTypeList", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "entityTypeChoice", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "categoryNameInput", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "required", void 0);
__decorate([
    mobx_1.observable
], AppSettingsAssets.prototype, "dummyCat", void 0);
AppSettingsAssets = __decorate([
    mobx_react_1.observer
], AppSettingsAssets);
exports.AppSettingsAssets = AppSettingsAssets;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-assets/app-settings-assets.tsx
// module id = 3169
// module chunks = 0